module.exports = __webpack_public_path__ + "fonts/Raleway-BlackItalic.7a1083e5.woff2";